import type { TransactionStatus } from '@hero/schema';
import { TransactionStatusBadge } from '../../Transaction/Status/TransactionStatusBadge';

export interface AccountTransactionStatusBadgeProps {
  status: TransactionStatus;
  showIcon?: boolean;
}

/**
 * Status pill for an `AccountTransaction`. The underlying status
 * enum is shared with the legacy `Transaction` collection, so we
 * re-export the existing badge directly — same colours, same
 * icons, same translation keys (`m-payment:transaction.status.*`).
 *
 * Lives in its own file so consumers can import it from the
 * `feature/AccountTransaction` barrel without reaching into
 * `feature/Transaction`, even though it's currently a thin shim.
 */
export function AccountTransactionStatusBadge({
  status,
  showIcon,
}: AccountTransactionStatusBadgeProps) {
  return <TransactionStatusBadge status={status} showIcon={showIcon} />;
}
